import { Common } from '~/models/common';
import { Image } from '~/models/image';
import { ReviewsGroup } from '~/models/reviews-group';

export namespace Reviews {
	export const collection = 'reviews';
	export const api = `/api/${collection}`;

	export type Model = Common.Model & {
		name: string;
		isVideo: boolean;
		photo: Image.Model;
		text: string;
		link: string;
		group: ReviewsGroup.Model;
	};

	export const modelState: Model = {
		...Common.modelState,
		name: '',
		isVideo: false,
		photo: Image.modelState,
		text: '',
		link: '',
		group: ReviewsGroup.modelState,
	};
}
